/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";
import Tooltip from "@mui/material/Tooltip";
import Icon from "@mui/material/Icon";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDBadgeDot from "components/MDBadgeDot";
import PieChart from "examples/Charts/PieChart";

// Data
//import channelChartData from "./data/orderAssignData";

// Material Dashboard 2 PRO React contexts
import { useMaterialUIController } from "context";

function ChannelsChart({ chartData,title }) {
  //console.log(title,"title from channelschart");
  const isQC = title.includes("QC");
  const label = isQC ? "Completed Orders QC" : "Completed Orders";
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const completedIndex = chartData?.labels?.indexOf("Completed");
  const completedOrders =
  completedIndex >= 0 && chartData?.datasets?.data
    ? chartData.datasets.data[completedIndex]
    : 0;

const totalOrders =
  chartData?.datasets?.data?.reduce((acc, val) => acc + val, 0) || 0;

const percentage = totalOrders > 0
  ? Math.round((completedOrders / totalOrders) * 100)
  : 0;


  return (
    <Card sx={{ height: "100%" }}>
      <MDBox display="flex" justifyContent="center" alignItems="center" pt={1}>
        <MDTypography variant="h6" textAlign="center">{title}</MDTypography>
        {/* <Tooltip title="See traffic channels" placement="bottom" arrow>
          <MDButton variant="outlined" color="secondary" size="small" circular iconOnly>
            <Icon>priority_high</Icon>
          </MDButton>
        </Tooltip> */}
      </MDBox>
      <MDBox>
        <Grid container alignItems="center">
          <Grid item xs={6}>
            <PieChart chart={chartData} height="9rem" />
          </Grid>
          <Grid item xs={6}>
            <MDBox pr={1}>
              {/* <MDBox mb={1}>
                <MDBadgeDot color="info" size="sm" badgeContent="Completed" />
              </MDBox>
              <MDBox mb={1}>
                <MDBadgeDot color="primary" size="sm" badgeContent="Incomplete" />
              </MDBox> */}
              <MDBox mb={1}>
              <MDTypography variant="button" color="text">
          Percentage: 
          <MDTypography variant="button" fontWeight="bold" color="dark"> {percentage} %
          </MDTypography>
        </MDTypography>
        </MDBox>
        <MDBox mb={1}>
        <MDTypography variant="button" color="text">
          {label}:{" "}
          <MDTypography variant="button" fontWeight="bold" color="dark">
            {/* {completedOrders}/{totalOrders} */}
            {isQC ? completedOrders : `${completedOrders}/${totalOrders}`}
          </MDTypography>
        </MDTypography>
        </MDBox>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
       {/* ✅ Show Completed Order Count at Bottom */}
        {/* <MDBox px={1} textAlign="center">
        <MDTypography variant="button" color="text">
          Percentage: {percentage} %
        </MDTypography>
      </MDBox> 
      <MDBox px={1} textAlign="center">
        <MDTypography variant="button" color="text">
          {label}:{" "}
          <MDTypography variant="button" fontWeight="bold" color="dark">
            {isQC ? completedOrders : `${completedOrders}/${totalOrders}`}
          </MDTypography>
        </MDTypography>
      </MDBox>  */}
      {/* <MDBox
        pt={4}
        pb={2}
        px={2}
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }}
        mt="auto"
      >
      </MDBox> */}
    </Card>
  );
}

export default ChannelsChart;
